export enum BilledToType {
    TriAx = 0,
    Customer = 1,
    Custom = 2,
}

export const BilledToTypeToLabel = [
    { value: BilledToType.TriAx, label: 'TriAx' },
    { value: BilledToType.Customer, label: 'Customer' },
    { value: BilledToType.Custom, label: 'Custom' },
];

export const BilledToLabelToType = {
    'TriAx': BilledToType.TriAx,
    'Customer': BilledToType.Customer,
    'Custom': BilledToType.Custom,
};

export function BilledToTypeToText(isBilledTo: BilledToType | undefined, customerName: string, billedTo?: string): string {
    let billToText = '';

    if (isBilledTo === BilledToType.TriAx) {
        billToText = 'TRI AX INC';
    }
    else if (isBilledTo === BilledToType.Customer) {
        billToText = customerName;
    }
    else {
        billToText = billedTo ?? '';
    }

    return billToText;
}
